export default "/images/warning.svg?4b07b3c8293deeee9de25d75e5571349";